module.exports = __webpack_public_path__ + "img/bottom_icon5.5b5f263b_5b5f263b08088f5d093550251f8d1639.5b5f263b.png";